import ResultDetails from './resultDetails.js';
export default ResultDetails;
